import { useTranslation } from "react-i18next";
import { Button, Stack, Typography } from "~/common/mui";
import { formatAsmTimer } from "~/features/assistedService/utils/asmTimer";

interface Props {
  remainingSeconds: number;
  onReset: () => void;
  className?: string;
  sx?: object;
}

/** ASM agent-session countdown. At 0 the hook fires `/logoutasm`; the reset button hits `/resetSession`. */
export const AsmTimer = ({ remainingSeconds, onReset, className, sx }: Props) => {
  const { t } = useTranslation();
  return (
    <Stack className={className} sx={sx} direction="row" spacing={1} alignItems="center">
      <Typography variant="bodyMedium" component="span">
        {t("asm.emulate.timer")}
      </Typography>
      <Typography variant="bodyMedium" component="span">
        {formatAsmTimer(remainingSeconds)}
      </Typography>
      <Button variant="text" size="small" onClick={onReset} disabled={remainingSeconds <= 0}>
        {t("asm.emulate.reset")}
      </Button>
    </Stack>
  );
};
